/**
 * @desc: 涉控黑名单
 * @created: 2020/5/22
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T3/involvedBlacklist'

export default {
  namespaced: true,
  actions: {
    getListData(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    getTiskBlackResp(ctx, payload) {
      return Models.getTiskBlackResp(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    async setRiskBlackMark(ctx, payload) {
      return await Models.setRiskBlackMark(payload)
    },

    async endRiskBlackMark(ctx, payload) {
      return await Models.endRiskBlackMark(payload)
    }
  }
}
